module.exports = __webpack_public_path__ + "static/img/p7.e54419a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p7.png
// module id = 249
// module chunks = 1